@if (this.isPrintable()) {
  @if (this.isZebra()) {
    <div class='stockLabel zebra'
      [class.portrait]='this.isPortrait()'
      [style.width.mm]='this.layout.widthMm'
      [style.height.mm]='this.layout.heightMm'>
      <div class='stockLabelQr' [style.width.mm]='this.qrSizeMm()' [style.height.mm]='this.qrSizeMm()'>
        <qr-code
          [value]='this.getPayload()'
          [size]='this.qrSizePx()'
          [errorCorrectionLevel]="'M'"
          [margin]='2'
        ></qr-code>
      </div>
      <div class='stockLabelText'>
        <strong [style.font-size.mm]='this.fontSizesMm().title'>{{ this.title }}</strong>
        <span [style.font-size.mm]='this.fontSizesMm().subtitle'>{{ this.subtitle }}</span>
        @if (this.reference) {
          <small [style.font-size.mm]='this.fontSizesMm().reference'>{{ this.reference }}</small>
        }
      </div>
    </div>
  } @else {
    <div class='stockLabel'>
      <qr-code
        [value]='this.getPayload()'
        [size]='140'
        [errorCorrectionLevel]="'M'"
        [margin]='2'
      ></qr-code>
      <div class='stockLabelText'>
        <strong>{{ this.title }}</strong>
        <span>{{ this.subtitle }}</span>
        @if (this.reference) {
          <small>{{ this.reference }}</small>
        }
      </div>
    </div>
  }
} @else {
  <div class='alert alert-warning'>This record has not been saved yet, so it cannot be labelled.</div>
}
